var l = (e, n, t) => {
  if (!n.has(e))
    throw TypeError("Cannot " + t);
};
var u = (e, n, t) => (l(e, n, "read from private field"), t ? t.call(e) : n.get(e)), h = (e, n, t) => {
  if (n.has(e))
    throw TypeError("Cannot add the same private member more than once");
  n instanceof WeakSet ? n.add(e) : n.set(e, t);
}, d = (e, n, t, r) => (l(e, n, "write to private field"), r ? r.call(e, t) : n.set(e, t), t);
var w = (e, n, t) => (l(e, n, "access private method"), t);
import { M } from "./MeterEntity-128e0f97.mjs";
function P(e) {
  return typeof e != "string" ? e : e.replace(/-/g, "_");
}
var m, a, c, p, g;
class $ extends M {
  constructor({ gtmDecorator: t, handleGtmEvent: r, handleGtmEventName: i, ...s }) {
    super({ ...s });
    h(this, p);
    h(this, m, !1);
    h(this, a, null);
    h(this, c, null);
    if (d(this, m, t), r && typeof r != "function")
      throw new Error("handleGtmEvent argument must be a function");
    if (d(this, a, r), i && typeof i != "function")
      throw new Error("handleGtmEventName argument must be a function");
    d(this, c, i);
  }
  init(t) {
    this.setMeter(t), this._queue.setMeter(this._meter), this._meter.event = this.produceEvent.bind(this), u(this, m) && w(this, p, g).call(this);
  }
  produceEvent({ name: t, value: r, ...i }) {
    if (t === void 0)
      throw new Error("event() argument name is required");
    const s = P(t);
    this.addInQueue({
      type: "event",
      name: `${this._eventNamePrefix}${s}`,
      labels: {
        pagePath: this.handlePagePath(window.location.pathname),
        ...this._customAttributes,
        ...i
      },
      ...r !== void 0 && { value: r }
    });
  }
}
m = new WeakMap(), a = new WeakMap(), c = new WeakMap(), p = new WeakSet(), g = function() {
  if (window.dataLayer) {
    const t = (r) => (...i) => {
      const s = r.apply(this, i);
      let o = Object.entries(i[0]).reduce((y, [v, b]) => (E(y, v, b), y), {});
      u(this, a) && (o = u(this, a).call(this, o));
      let f;
      return o["gtm.event"] ? f = o["gtm.event"] : f = "gtmEvent", u(this, c) && (f = u(this, c).call(this, f, o)), this.produceEvent({
        name: f,
        ...o
      }), s;
    };
    window.dataLayer.push = t(window.dataLayer.push);
  }
};
function E(e, n, t, r = 0) {
  if (!(r > 5)) {
    if (_(t))
      e[`gtm.${n}`] = "HTMLElement";
    else if (typeof t != "object")
      e[`gtm.${n}`] = t;
    else
      for (const i in t)
        if (Object.hasOwnProperty.call(t, i)) {
          const s = t[i];
          E(e, [n, i].join("."), s, r + 1);
        }
  }
}
function _(e) {
  try {
    return e instanceof HTMLElement;
  } catch {
    return typeof e == "object" && e.nodeType === 1 && typeof e.style == "object" && typeof e.ownerDocument == "object";
  }
}
export {
  $ as default
};
